<template>
  <navbar inverse>
    <a class="navbar-brand" slot="brand" href="/">SPIADI BO</a>
    <template slot="collapse">
      <navbar-nav>
        <dropdown tag="li" v-for="(n, k) in destinations"
                  :key="`${k}-dest`">
          <a class="dropdown-toggle" role="button">
            {{n.title}} <span class="caret"></span>
          </a>
          <template slot="dropdown">
            <li v-for="(l, kl) in n.links" :key="`${kl}-link`"
                v-show="l.show == null || l.show()">
              <router-link tag="a" :to="l.to">
                {{ l.name }}
              </router-link>
            </li>
          </template>
        </dropdown>
      </navbar-nav>
      <navbar-nav :right=true>
        <navbar-text v-if="loginState">
          <strong>{{ name }}</strong>
          (<a @click="logout" class="navbar-link" role="button">Se déconnecter</a>)
        </navbar-text>
        <router-link tag="li" to="/mission" active-class="active"
                     v-if="loginState.isUser">
          <a role="button">SPIADI</a>
        </router-link>
        <router-link tag="li" to="/admin" active-class="active"
                     v-if="loginState.isAdmin">
          <a role="button">Back Office</a>
        </router-link>
      </navbar-nav>
    </template>
  </navbar>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'navigation',

  computed: {
    ...mapGetters({
      loginState: 'login/loginState',
      name: 'login/completeName'
    }),

    isMedical: function () {
      return this.loginState.isMedical
    },

    isRegion: function () {
      return this.loginState.isCpias
    },

    destinations: function () {
      const vm = this
      const path = this.$route.path
      let nav = 'mission'
      if (path.startsWith('/admin')) {
        nav = 'admin'
      } else if (this.isRegion) {
        nav = 'region'
      }
      const navs = {
        admin: [
          {
            title: 'Utilisateurs',
            links: [
              {
                to: '/admin/list',
                name: 'Liste'
              },
              {
                to: '/admin/zombies',
                name: 'Zombies'
              },
              {
                to: '/admin/add',
                name: 'Ajouter'
              },
              {
                to: '/admin/import',
                name: 'Importer'
              }
            ]
          },
          {
            title: 'Administration',
            links: [
              {
                to: '/admin/db',
                name: 'Base de données'
              },
              {
                to: '/admin/datasets',
                name: 'Datasets'
              }
            ]
          }
        ],

        region: [
          {
            title: 'Outils',
            links: [
              {
                to: '/tools/caracteristics',
                name: 'Caractéristiques libres'
              }
            ]
          },
          {
            title: '2026',
            links: [
              {
                to: '/region/2026/surveillances',
                name: 'Inscriptions'
              },
              {
                to: '/region/2026/sheets/statistics',
                name: 'Statistiques'
              },
              {
                to: '/region/2026/data',
                name: 'Résultats Surveillance',
                show: () => vm.isMedical
              },
              {
                to: '/region/2026/o4results',
                name: 'Résultats OBSERVA4',
                show: () => vm.isMedical
              }

            ]
          },
          {
            title: '2025',
            links: [
              {
                to: '/region/2025/surveillances',
                name: 'Inscriptions'
              },
              {
                to: '/region/2025/sheets/statistics',
                name: 'Statistiques'
              },
              {
                to: '/region/2025/data',
                name: 'Résultats Surveillance',
                show: () => vm.isMedical
              },
              {
                to: '/region/2025/o4results',
                name: 'Résultats OBSERVA4',
                show: () => vm.isMedical
              }

            ]
          },
          {
            title: '2024',
            links: [
              {
                to: '/region/2024/surveillances',
                name: 'Inscriptions'
              },
              {
                to: '/region/2024/sheets/statistics',
                name: 'Statistiques'
              },
              {
                to: '/region/2024/data',
                name: 'Résultats Surveillance',
                show: () => vm.isMedical
              },
              {
                to: '/region/2024/o4results',
                name: 'Résultats OBSERVA4',
                show: () => vm.isMedical
              }

            ]
          },
          {
            title: '2023',
            links: [
              {
                to: '/region/2023/surveillances',
                name: 'Inscriptions'
              },
              {
                to: '/region/2023/sheets/statistics',
                name: 'Statistiques'
              },
              {
                to: '/region/2023/data',
                name: 'Résultats Surveillance',
                show: () => vm.isMedical
              },
              {
                to: '/region/2023/o4results',
                name: 'Résultats OBSERVA4',
                show: () => vm.isMedical
              }

            ]
          },
          {
            title: '2022',
            links: [
              {
                to: '/region/2022/surveillances',
                name: 'Inscriptions'
              },
              {
                to: '/region/2022/sheets/statistics',
                name: 'Statistiques'
              },
              {
                to: '/region/2022/data',
                name: 'Résultats Surveillance',
                show: () => vm.isMedical
              },
              {
                to: '/region/2022/o4results',
                name: 'Résultats OBSERVA4',
                show: () => vm.isMedical
              }

            ]
          },
          {
            title: '2021',
            links: [
              {
                to: '/region/2021/surveillances',
                name: 'Inscriptions'
              },
              {
                to: '/region/2021/sheets/statistics',
                name: 'Statistiques'
              },
              {
                to: '/region/2021/data',
                name: 'Résultats Surveillance',
                show: () => vm.isMedical
              },
              {
                to: '/region/2021/o4results',
                name: 'Résultats OBSERVA4',
                show: () => vm.isMedical
              }
            ]
          },
          {
            title: '2020',
            links: [
              {
                to: '/region/2020/surveillances',
                name: 'Inscriptions'
              },
              {
                to: '/region/2020/sheets/statistics',
                name: 'Statistiques'
              },
              {
                to: '/region/2020/data',
                name: 'Résultats Surveillance',
                show: () => vm.isMedical
              }
            ]
          },

          {
            title: '2019',
            links: [
              {
                to: '/region/2019/surveillances',
                name: 'Inscriptions'
              },
              {
                to: '/region/2019/sheets/statistics',
                name: 'Statistiques'
              }
            ]
          }
        ],

        mission: [
          {
            title: 'Utilisateurs',
            links: [
              {
                to: '/mission/list',
                name: 'Liste'
              },
              {
                to: '/mission/add',
                name: 'Ajouter'
              },
              {
                to: '/mission/import',
                name: 'Importer'
              }
            ]
          },
          {
            title: 'Listes',
            links: [
              {
                to: '/mission/establishments',
                name: 'Établissements'
              },
              {
                to: '/mission/sheets',
                name: 'Fiches',
                show: () => vm.isMedical
              }
            ]
          },
          {
            title: 'Outils',
            links: [
              {
                to: '/tools/evolution',
                name: 'Évolution des incidences'
              },
              {
                to: '/tools/caracteristicsEvolution',
                name: 'Évolution des caractéristiques',
                show: () => vm.isMedical
              },
              {
                to: '/tools/cohorts',
                name: 'Cohortes',
                show: () => vm.isMedical
              },
              {
                to: '/tools/caracteristics',
                name: 'Caractéristiques libres'
              },
              {
                to: '/tools/participation',
                name: 'Participation'
              },
              {
                to: '/tools/map',
                name: 'Carte'
              }
            ]
          },
          {
            title: '2026',
            links: [
              {
                to: '/mission/2026/surveillances',
                name: 'Inscriptions'
              },
              {
                to: '/mission/2026/sheets/statistics',
                name: 'Statistiques'
              },
              {
                to: '/mission/2026/sheets/import',
                name: 'Import',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2026/explaur',
                name: 'RÉA-explAUR'
              },
              {
                to: '/mission/2026/sheets/export',
                name: 'Export CSV'
              },
              {
                to: '/mission/2026/results',
                name: 'Incidences'
              },
              {
                to: '/mission/2026/data',
                name: 'Résultats Surveillance',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2026/o4results',
                name: 'Résultats OBSERVA4',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2026/sheets/caracteristics',
                name: 'Caractéristiques',
                show: () => vm.isMedical
              }
            ]
          },
          {
            title: '2025',
            links: [
              {
                to: '/mission/2025/surveillances',
                name: 'Inscriptions'
              },
              {
                to: '/mission/2025/sheets/statistics',
                name: 'Statistiques'
              },
              {
                to: '/mission/2025/sheets/import',
                name: 'Import',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2025/explaur',
                name: 'RÉA-explAUR'
              },
              {
                to: '/mission/2025/sheets/export',
                name: 'Export CSV'
              },
              {
                to: '/mission/2025/results',
                name: 'Incidences'
              },
              {
                to: '/mission/2025/data',
                name: 'Résultats Surveillance',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2025/o4results',
                name: 'Résultats OBSERVA4',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2025/sheets/caracteristics',
                name: 'Caractéristiques',
                show: () => vm.isMedical
              }
            ]
          },
          {
            title: '2024',
            links: [
              {
                to: '/mission/2024/surveillances',
                name: 'Inscriptions'
              },
              {
                to: '/mission/2024/sheets/statistics',
                name: 'Statistiques'
              },
              {
                to: '/mission/2024/sheets/import',
                name: 'Import',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2024/explaur',
                name: 'RÉA-explAUR'
              },
              {
                to: '/mission/2024/sheets/export',
                name: 'Export CSV',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2024/results',
                name: 'Incidences'
              },
              {
                to: '/mission/2024/data',
                name: 'Résultats Surveillance',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2024/o4results',
                name: 'Résultats OBSERVA4',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2024/sheets/caracteristics',
                name: 'Caractéristiques',
                show: () => vm.isMedical
              }
            ]
          },
          {
            title: '2023',
            links: [
              {
                to: '/mission/2023/surveillances',
                name: 'Inscriptions'
              },
              {
                to: '/mission/2023/sheets/statistics',
                name: 'Statistiques'
              },
              {
                to: '/mission/2023/explaur',
                name: 'RÉA-explAUR'
              },
              {
                to: '/mission/2023/sheets/export',
                name: 'Export CSV',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2023/results',
                name: 'Incidences'
              },
              {
                to: '/mission/2023/data',
                name: 'Résultats Surveillance',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2023/o4results',
                name: 'Résultats OBSERVA4',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2023/sheets/caracteristics',
                name: 'Caractéristiques',
                show: () => vm.isMedical
              }
            ]
          },
          {
            title: '2022',
            links: [
              {
                to: '/mission/2022/surveillances',
                name: 'Inscriptions'
              },
              {
                to: '/mission/2022/sheets/statistics',
                name: 'Statistiques'
              },
              {
                to: '/mission/2022/explaur',
                name: 'RÉA-explAUR'
              },
              {
                to: '/mission/2022/sheets/export',
                name: 'Export CSV',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2022/results',
                name: 'Incidences'
              },
              {
                to: '/mission/2022/data',
                name: 'Résultats Surveillance',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2022/o4results',
                name: 'Résultats OBSERVA4',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2022/sheets/caracteristics',
                name: 'Caractéristiques',
                show: () => vm.isMedical
              }
            ]
          },
          {
            title: '2021',
            links: [
              {
                to: '/mission/2021/surveillances',
                name: 'Inscriptions'
              },
              {
                to: '/mission/2021/sheets/statistics',
                name: 'Statistiques'
              },
              {
                to: '/mission/2021/explaur',
                name: 'RÉA-explAUR'
              },
              {
                to: '/mission/2021/sheets/export',
                name: 'Export CSV',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2021/results',
                name: 'Incidences'
              },
              {
                to: '/mission/2021/data',
                name: 'Résultats Surveillance',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2021/o4results',
                name: 'Résultats OBSERVA4',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2021/sheets/caracteristics',
                name: 'Caractéristiques',
                show: () => vm.isMedical
              }
            ]
          },
          {
            title: '2020',
            links: [
              {
                to: '/mission/2020/surveillances',
                name: 'Inscriptions'
              },
              {
                to: '/mission/2020/sheets/statistics',
                name: 'Statistiques'
              },
              {
                to: '/mission/2020/sheets/export',
                name: 'Export CSV',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2020/results',
                name: 'Incidences'
              },
              {
                to: '/mission/2020/data',
                name: 'Résultats Surveillance',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2020/o4results',
                name: 'Résultats OBSERVA4',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2020/sheets/caracteristics',
                name: 'Caractéristiques',
                show: () => vm.isMedical
              }
            ]
          },

          {
            title: '2019',
            links: [
              {
                to: '/mission/2019/surveillances',
                name: 'Inscriptions'
              },
              {
                to: '/mission/2019/sheets/statistics',
                name: 'Statistiques'
              },
              {
                to: '/mission/2019/surveys',
                name: 'Sondages'
              },
              {
                to: '/mission/2019/sheets/export',
                name: 'Export CSV',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2019/results',
                name: 'Incidences'
              },
              {
                to: '/mission/2019/data',
                name: 'Résultats Surveillance',
                show: () => vm.isMedical
              },
              {
                to: '/mission/2019/sheets/caracteristics',
                name: 'Caractéristiques',
                show: () => vm.isMedical
              }
            ]
          }
        ]
      }
      return navs[nav]
    }
  },
  methods: {
    logout: function () {
      this.$store.dispatch('login/logout', 'user')
      this.$router.push('/login')
    },

    login: function () {
      this.$router.push('/login')
    }
  }
}
</script>
<style scoped>
.navbar {
    margin-bottom: 0px;
    border-radius: 0px;
}
</style>
